module.exports = __webpack_public_path__ + "static/media/ZenLogo.6ce6a3fd.png";